<template>
  <cf-expandable-section>
    <template #title>
      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        Shipping as a gift? Add an optional note
      </p>
    </template>

    <template #content>
      <cf-text-input
        v-model="internalValue"
        type="text"
        label="Gift Note"
        name="shippingGiftMessage"
        :show-as-optional="true"
        :validations="{ max: 200 }"
      />
    </template>
  </cf-expandable-section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfExpandableSection from '@/view/components/shared/cf-expandable-section/index.vue';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfAddShippingGiftNote',

    components: {
      CfExpandableSection,
      CfTextInput
    },

    props: {
      modelValue: {
        type: String,
        default: null
      }
    },

    computed: {
      ...mapGetters('content', ['content']),

      internalValue: {
        get() {
          return this.modelValue;
        },

        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  };
</script>
